import React, { useState, useEffect } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment'

import formatDate from 'helpers/dateTimeFormatter'
import { ContentBlock } from 'components/ContentBlock'
import { DataTable } from 'components/DataTable'
import { TextEditor, DateTimePicker } from 'components/forms'
import { clientMessages, allMessages } from '../tableColumns'
import Divider from 'components/Divider'
import Button from 'components/Button'

import { StyledParagraph } from '../styled'

const Message = ({ data = [], filterValues, messageListData, dateInterval, setDateInterval, onClick }) => {
	const { t } = useTranslation()
	const [displayMessageDataTable, setDisplayMessageDataTable] = useState(false)
	const { isForShop, recipientShops, recipientUsers, answer, createdAt, body, sender } = data
	const [messageData, setMessageData] = useState(null)

	const getTableData = () => {
		const tableData = (isForShop ? recipientShops : recipientUsers)?.filter(i => i !== null)
		return tableData?.map(dataItem => {
			const newTableDataItem = {
				...dataItem,
				body,
				sender,
				isForShop,
				createdAt,
				answer: answer !== null ?
					answer.find(answerItem => (isForShop ? answerItem.shopId : answerItem.userId) === dataItem.id)
					: null
			}
			return newTableDataItem
		})
	}

	useEffect(()=> {
		if(messageData?.id && !displayMessageDataTable) {
			setDisplayMessageDataTable(true)
		}
	}, [messageData])

	return(
		<>
			<ContentBlock>
				{isEmpty(filterValues) ?
					<DataTable
						data={getTableData() || []}
						columns={clientMessages(t) || []}
						withSearch
						selectRow={{
							selected: messageData?.id,
							setSelectedRecord: () => null
						}}
						onRowClick={(tableProps, { original }) => setMessageData(original)}
						height={400}
					/>
					:
					<>
						<Row>
							<Col xs>
								<DateTimePicker
									label={{ from: t('common.fields.from_date'), to: t('common.fields.to_date') }}
									maxDate={moment().utc()}
									value={dateInterval}
									noForm
									picker='date'
									interval={true}
									placeholder={{
										from: t('common.placeholders.from_date'),
										to: t('common.placeholders.to_date')
									}}
									onChange={({ from, to }) => setDateInterval({ from, to })}
									popperModifiers={{
										flip: {
											enabled: false
										}
									}}
								/>
								<Button
									status='primary'
									type='submit'
									text={t('common.buttons.apply')}
									onClick={onClick}
								/>
							</Col>
						</Row>
						<Divider/>
						<DataTable
							columns={allMessages(t, isEmpty(filterValues)) || []}
							withSearch
							selectRow
							onRowClick={(tableProps, { original }) => setMessageData(original)}
							height={400}
							data={messageListData || []}
							defaultSorted={[
								{
									id: 'createdAt',
									desc: true
								}
							]}
						/>
					</>
				}
	    	</ContentBlock>
			{ displayMessageDataTable &&
			<ContentBlock>
				<Row>
					<Col xs={8}>
						<TextEditor
							key={messageData.id}
							label={t('message_section.caption')}
							defaultText={messageData.body ?? messageData.body}
							noForm
							readOnly
							withToolbar={false}
							height={300}
							style={{ maxWidth: '900px' }}
						/>
					</Col>
					<Col xs={4}>
						<Divider height={50}/>
						<ul>
							<li>
								<span>{`${t('message_section.fields.created')}:`}</span>
								<Divider height={15}/>
								<StyledParagraph>
									{formatDate(messageData.createdAt, 'DD.MM.YYYY HH:mm')}
								</StyledParagraph>
								<Divider/>
							</li>
							<li>
								<span>{`${t('message_section.fields.sender')}:`}</span>
								<Divider height={15}/>
								<StyledParagraph>{messageData.sender}</StyledParagraph>
								<Divider/>
							</li>
							{!isEmpty(filterValues) &&
								<>
									<li>
										<span>{`${t('message_section.fields.reply_to_user')}:`}</span>
										<Divider height={15}/>
										<StyledParagraph>
											{`${t('message_section.fields.answer')} 
											${formatDate(messageData.createdAt, 'YYYY')}`}
										</StyledParagraph>
										<Divider/>
									</li>
									<li>
										<span>{`${t('message_section.fields.user_answer')}:`}</span>
										<Divider height={15}/>
										<StyledParagraph>
											{`${t('message_section.strings.user')} 
											${formatDate(messageData.createdAt, 'YYYY')}`}
										</StyledParagraph>
										<Divider/>
									</li>
								</>
							}
						</ul>
					</Col>
				</Row>
			</ContentBlock>
			}
		</>
	)
}

export default Message

